import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ArrowUp = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7 11.2L12.7 6.2C12.3 5.8 11.7 5.8 11.3 6.2L6.3 11.2C5.9 11.6 5.9 12.2 6.3 12.6C6.7 13 7.3 13 7.7 12.6L11 9.4V17C11 17.6 11.4 18 12 18C12.6 18 13 17.6 13 17V9.4L16.3 12.7C16.7 13.1 17.3 13.1 17.7 12.7C18.1 12.3 18.1 11.6 17.7 11.2Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowUp
